import { MainPlayer } from "@components/layouts/b2c/layout/MainPlayer";
import { useAudioPlayer } from "@modules/content/AudioPlayerContext";

export const PlayerLayout = ({ children }: { children: React.ReactNode }) => {
  const { isShown } = useAudioPlayer();

  return (
    <div className="h-full w-full">
      {children}
      {isShown ? (
        <div className="fixed bottom-0 left-0 z-10 w-full">
          <MainPlayer />
        </div>
      ) : null}
    </div>
  );
};
